import React from 'react';
import AdminWriteComponent from '../../../components/admin/community/AdminWriteComponent';

const AdminWrite: React.FC = () => {
  return <AdminWriteComponent />;
};

export default AdminWrite;
